import { render, staticRenderFns } from "./RelatedItem.vue?vue&type=template&id=3c7eac23&scoped=true&"
import script from "./RelatedItem.vue?vue&type=script&lang=js&"
export * from "./RelatedItem.vue?vue&type=script&lang=js&"
import style0 from "./RelatedItem.vue?vue&type=style&index=0&id=3c7eac23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7eac23",
  null
  
)

export default component.exports